export class RoundRobinConnection {
  private index = 0;
  private urls: string[] = [];
  private allowedUrls?: Set<string>;

  constructor(urls: string[] = []) {
    if (urls.length) {
      this.setUrls(urls);
    }
  }

  setUrls(urls: string[]): void {
    if (!urls.length) {
      throw new Error('RoundRobinConnection: список URL пуст');
    }
    this.urls = [...urls];
    this.index = 0;
  }

  getIndex(): number {
    return this.index;
  }

  getUrls(): readonly string[] {
    return this.urls;
  }

  setAllowedUrls(urls: readonly string[]): void {
    this.allowedUrls = new Set(urls);
  }

  /** Возвращает URL по текущему индексу и сдвигает индекс к следующему элементу */
  next(): string {
    if (!this.urls.length) {
      throw new Error('RoundRobinConnection: список URL не задан');
    }

    const url = this.urls[this.index];
    this.index = (this.index + 1) % this.urls.length;
    return url;
  }

  /** Возвращает URL по текущему индексу без сдвига */
  current(): string {
    if (!this.urls.length) {
      throw new Error('RoundRobinConnection: список URL не задан');
    }

    return this.urls[this.index];
  }

  /** Сдвигает индекс к следующему элементу */
  advance(): void {
    if (!this.urls.length) {
      throw new Error('RoundRobinConnection: список URL не задан');
    }

    const startIndex = this.index;
    do {
      this.index = (this.index + 1) % this.urls.length;
    } while (!this.isCurrentUrlAllowed() && this.index !== startIndex);
  }

  /** Создаёт независимую копию с тем же списком URL и текущим индексом */
  clone(): RoundRobinConnection {
    const copy = new RoundRobinConnection();
    copy.urls = [...this.urls];
    copy.index = this.index;
    copy.allowedUrls = this.allowedUrls ? new Set(this.allowedUrls) : undefined;
    return copy;
  }

  /** Вручную установить индекс */
  setIndex(newIndex: number): void {
    this.index = newIndex;
  }

  // На всякий случай проверяем, что текущий url из списка валидных урлов
  private isCurrentUrlAllowed(): boolean {
    return !this.allowedUrls || this.allowedUrls.has(this.urls[this.index]);
  }
}
